var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.832 10l7.788-7.788c.507-.506.507-1.325 0-1.832-.507-.507-1.326-.507-1.832 0L10 8.168 2.212.38C1.705-.127.887-.127.38.38c-.507.507-.507 1.326 0 1.832L8.168 10 .38 17.788c-.507.507-.507 1.326 0 1.832.253.253.584.38.916.38.332 0 .664-.127.916-.38L10 11.832l7.788 7.788c.252.253.584.38.916.38.332 0 .663-.127.916-.38.507-.506.507-1.325 0-1.832L11.832 10z",
    transform: "translate(-1050 -422) translate(1050 422)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7f600a3c4d3487bad0905a81c15f1c59.svg";
export { ForwardRef as ReactComponent };